import React, { Component } from 'react'
import { connect } from 'react-redux'
import Login from './Login'
import { checkUserSession } from '../actions/user'
import { withRouter } from 'react-router-dom'
import Loader from '../components/Common/Loader'

class AuthProtected extends Component {

  componentDidMount() {
    this.props.checkSession()
  }

  render() {
    const { user, loading, children } = this.props
    const isLoginUrl = this.props.match.url === '/login'

    if (loading) {
      return <Loader/>
    }

    // if there's no user's id after authentication loading is done, user is not logged in
    if (!user.id || (user.isGuest && isLoginUrl)) {
      return <Login/>
    }

    // continue to protected part
    return children
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  loading: state.user.authenticationInProgress,
})

const mapDispatchToProps = (dispatch) => ({
  checkSession: () => dispatch(checkUserSession())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AuthProtected))
